import React, { Component } from 'react';

export default class IgCard extends Component {
  render() {
    const { src, comments, likes } = this.props;
    return (
      <div
        className="component-igCard"
      >
        <img src={src} alt="" />
        <div className="overlay-hover">
          <button className="section-icon" onClick={() => console.log('ig >> message')}>
            <i className="icon-massage whiteGray" />
            <h3 className="count-text whiteGray">{comments}</h3>
          </button>
          <button className="section-icon" onClick={() => console.log('ig >> heart')}>
            <i className="icon-heart whiteGray" />
            <h3 className="count-text whiteGray">{likes}</h3>
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IgCard.js